import React from 'react';
import { FaLinkedin, FaInstagram, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-r from-pink-400 via-purple-300 to-yellow-200 py-16 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between gap-8 items-center text-gray-700 text-sm">
        {/* Left Section: Copyright & Privacy Policy */}
        <div className="text-center md:text-left">
          © 2025 WETRND Private Limited |{' '}
          <a
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 transition-colors duration-200"
          >
            Privacy Policy
          </a>
        </div>

        {/* Center Section: Address */}
        <address className="not-italic text-center md:text-left text-gray-700 leading-relaxed max-w-md">
          WETRND PVT. LTD.<br />
          UNIT NO. A-120, AKSHAY MITTAL INDUSTRIAL ESTATE,<br />
          A-WING, BUILDING NO.5B,<br />
          MAROL, ANDHERI (EAST),<br />
          MUMBAI - 400059
        </address>

        {/* Right Section: Social Media Icons */}
        <div className="flex space-x-3 flex-shrink-0">
          <a
            href="https://linkedin.com/company/wetrnd"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-white bg-opacity-20 backdrop-blur-sm rounded-lg flex items-center justify-center text-gray-700 hover:bg-opacity-30 hover:text-gray-900 transition-all duration-200 hover:scale-105"
            aria-label="LinkedIn"
          >
            <FaLinkedin size={18} />
          </a>
          <a
            href="https://instagram.com/wetrnd_"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-white bg-opacity-20 backdrop-blur-sm rounded-lg flex items-center justify-center text-gray-700 hover:bg-opacity-30 hover:text-gray-900 transition-all duration-200 hover:scale-105"
            aria-label="Instagram"
          >
            <FaInstagram size={18} />
          </a>
          <a
            href="https://x.com/wetrnd"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 bg-white bg-opacity-20 backdrop-blur-sm rounded-lg flex items-center justify-center text-gray-700 hover:bg-opacity-30 hover:text-gray-900 transition-all duration-200 hover:scale-105"
            aria-label="Twitter"
          >
            <FaTwitter size={18} />
          </a>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-4 left-4 w-16 h-16 bg-white bg-opacity-10 rounded-full"></div>
      <div className="absolute bottom-4 right-4 w-12 h-12 bg-white bg-opacity-10 rounded-full"></div>
    </footer>
  );
};

export default Footer;
